import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "left-jt",
  "use": "left-jt-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"left-jt\"><defs><style type=\"text/css\"></style></defs><path d=\"M725.333 262.912v-49.579l-426.667 257.195v43.392l426.667 254.080v-52.694l-389.035-223.104 389.035-229.291z\" p-id=\"2830\" fill=\"#46cf7d\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/left-jt.svg
// module id = tdyv
// module chunks = 38